<span 
  [class]="textClasses()"
  [title]="truncate() ? text() : ''">
  {{ text() }}
</span>